/**
 * Parses a campaign description markdown to extract eligibility requirements.
 * Looks for bullet points under an "eligibility" heading.
 */
export function parseEligibilityRequirements(description: string): string[] {
  const lines = description.split("\n");
  const requirements: string[] = [];
  let inEligibilitySection = false;

  for (const line of lines) {
    const trimmed = line.trim();

    // Detect eligibility section header (case-insensitive, may have emoji prefix)
    if (/eligib/i.test(trimmed) && (trimmed.endsWith(":") || trimmed.endsWith("："))) {
      inEligibilitySection = true;
      continue;
    }

    if (inEligibilitySection) {
      const bulletMatch = trimmed.match(/^[-*•]\s+(.*)/);
      if (bulletMatch?.[1]) {
        requirements.push(bulletMatch[1]);
      } else if (trimmed === "") {
        continue;
      } else if (
        !trimmed.startsWith("-") &&
        !trimmed.startsWith("*") &&
        !trimmed.startsWith("•") &&
        trimmed.length > 0
      ) {
        break;
      }
    }
  }

  return requirements;
}
